// @flow

import React from 'react';
import { FormGroup } from 'reactstrap';

import { getErrorClassName } from '@dom/utils';
import { Error } from '@dom/components';

type Props = {
  label: string,
  Type: React.ReactComponentElement,
  setError: (elementType: string, error: string) => void,
  error: string,
  wrap: boolean,
};

StripeInput.defaultProps = {
  wrap: true,
};

export default function StripeInput(props: Props) {
  const { label, Type, setError, error, wrap, name, className } = props;

  const listenError = ({ elementType, error }) => {
    setError(elementType, error ? error.message : '');
  };

  const body = (
    <div className={className}>
      <label htmlFor={name}>{label}</label>
      <Type
        id={name}
        onChange={listenError}
        className={`form-control ${getErrorClassName(error)}`}
      />
      <Error error={error} />
    </div>
  );

  return wrap ? <FormGroup>{body}</FormGroup> : { body };
}
